const AUTH_TOKEN_KEY = 'auth-token'
const LOCALSTORAGE_CART_KEY = 'edugram-cart-items'
const LOCALSTORAGE_WISHLIST_KEY = 'edugram-wishlist-items'
const LOCALSTORAGE_SAVED_CART_ITEMS_KEY = 'edugram-saved-cart-items'
const LOCALSTORAGE_BUY_NOW_KEY = 'edugram-buy-now-item'
const LOCALSTORAGE_INACTIVE_CART_ITEMS_KEY = 'edugram-inactive-cart-items'
const LOCALSTORAGE_CART_ITEM_TYPE_KEY = 'edugram-cart-item-key'
const LOCALSTORAGE_PL = 'edugram-pl'
const LOCALSTORAGE_MUID = 'edugram-muid'
const LOCALSTORAGE_CID = 'edugram-cid'

export {
  AUTH_TOKEN_KEY,
  LOCALSTORAGE_CART_KEY,
  LOCALSTORAGE_WISHLIST_KEY,
  LOCALSTORAGE_SAVED_CART_ITEMS_KEY,
  LOCALSTORAGE_BUY_NOW_KEY,
  LOCALSTORAGE_INACTIVE_CART_ITEMS_KEY,
  LOCALSTORAGE_CART_ITEM_TYPE_KEY,
  LOCALSTORAGE_MUID,
  LOCALSTORAGE_CID,
  LOCALSTORAGE_PL,
}
